import * as React from "react";
import { IDockviewPanelProps } from "dockview";
import { observer } from "mobx-react-lite";
import { Dataset, Func } from "bundles/BigqueryQueryViewer/store";
import styles from "./style.module.css";
import I18n from "lib/I18n";
import { Card, Col, Container, Row } from "react-bootstrap";

export const FuncComponent = observer(
  (props: IDockviewPanelProps<{ dataset: Dataset; func: Func }>) => {
    const { dataset, func } = props.params;

    return (
      <div className={styles.root}>
        <div className={styles.block}>
          <h4>{I18n.t("bigquery_query_viewer.label.func_info")}</h4>
          <Container fluid>
            <p>{func.description}</p>
            <Row>
              <Col xs="3">
                {I18n.t("bigquery_query_viewer.label.dataset_id")}
              </Col>
              <Col xs="9">{dataset.name}</Col>
            </Row>
            <Row>
              <Col xs="3">{I18n.t("bigquery_query_viewer.label.func_id")}</Col>
              <Col xs="9">{func.name}</Col>
            </Row>
          </Container>
        </div>
        <div className={styles.block}>
          <h4>{I18n.t("bigquery_query_viewer.label.func_content")}</h4>
          <Container fluid>
            <Card bg="light">
              <Card.Body>
                <pre style={{ margin: 0 }}>{func.content}</pre>
              </Card.Body>
            </Card>
          </Container>
        </div>
        <div className={styles.block}>
          <h4>{I18n.t("bigquery_query_viewer.label.func_example")}</h4>
          <Container fluid>
            <Card bg="light">
              <Card.Body>
                <pre style={{ margin: 0 }}>{func.example}</pre>
              </Card.Body>
            </Card>
          </Container>
        </div>
      </div>
    );
  },
);
